<template>
  <div class="header">
    <div class="bread">
      <div class="menu">
        <a href="" @click.prevent.stop="onCollapsed">
          <MenuFoldOutlined v-if="!collapsed" />
          <MenuUnfoldOutlined v-else />
        </a>
      </div>

      <a href="" @click.prevent.stop="onBackHome"
        style="color: rgba(0, 0, 0, 0.45); font-size: 14px; margin-right: 2px">
        <HomeOutlined />
      </a>
      <a-breadcrumb :routes="routes" separator=">">
        <template #itemRender="{ route, routes }">
          <span v-if="routes.indexOf(route) === routes.length - 1">
            {{ route.breadcrumbName }}
          </span>
          <router-link v-else :to="route.path">
            {{ route.breadcrumbName }}
          </router-link>
        </template>
      </a-breadcrumb>
    </div>

    <div class="user-info">
      <div class="user-avatar">
        <router-link to="/account/info">
          <img :src="userInfo?.avatar" :alt="userInfo?.name" />
        </router-link>
      </div>
      <div class="user-name">
        <router-link to="/account/info">
          {{ userInfo?.name ?? userInfo?.nickname }}
        </router-link>
      </div>
      <div class="btns">
        <a-tooltip>
          <template #title>修改密码</template>
          <router-link to="/account/safe">
            <KeyOutlined /> &nbsp;修改密码
          </router-link>
        </a-tooltip>

        <a-tooltip>
          <template #title>退出登录</template>
          <a @click.stop="onLogout">
            <LogoutOutlined /> &nbsp; 退出登录
          </a>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useUserStore } from '@/store'
import { MenuFoldOutlined, MenuUnfoldOutlined, HomeOutlined, KeyOutlined, LogoutOutlined } from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import { Route } from 'ant-design-vue/es/breadcrumb/Breadcrumb'
import router from '@/router'

const route = useRoute()
const collapsed = ref(false)
const routes = ref<Route[]>([])
const userStore = useUserStore()
const userInfo = ref(userStore.userInfo)

// eslint-disable-next-line no-undef
const emit = defineEmits(['collapsed'])

const onCollapsed = () => {
  collapsed.value = !collapsed.value
  emit('collapsed', collapsed.value)
}
const onBackHome = () => {
  console.log('111')
}
const onLogout = () => {
  userStore.onLogout().then(() => {
    router.push({ name: 'manage-login' })
  })
}

const updateRoute = () => {
  const { matched } = route
  const list: Route[] = []
  matched.forEach((e) => {
    list.push({
      path: (e.path === '/manage' || e.path === '/account') ? '/manage' : e.path,
      breadcrumbName: (e.path === '/manage' || e.path === '/account') ? '首页' : e.meta.title as string
    })
  })

  routes.value = list
}

watch(route, () => {
  // console.log('路由变化', e)
  updateRoute()
}, { immediate: true })
</script>


<style lang="less" scoped>
.header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;

  .bread {
    display: flex;
    align-items: center;

    .menu {
      margin-right: 20px;
    }
  }

  .user-info {
    display: flex;
    align-items: center;

    .user-avatar {
      width: 39px;
      height: 39px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #ccc;

      img {
        display: block;
        width: 100%;
      }
    }

    .user-name {
      font-size: 14px;
      padding: 0 5px;
    }

    .btns {
      display: flex;
      align-items: center;
      padding-left: 20px;

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 7px;
        font-size: 14px;
        color: #333;
      }
    }
  }
}
</style>